import React, { useState } from "react";
import { Text, SwitchField, Flex, TextField, Button, useAuthenticator, Loader, View, AccountSettings, Heading } from "@aws-amplify/ui-react";
import { I18n } from "aws-amplify/utils";

const ProfilePassword = (props) => {
  I18n.putVocabulariesForLanguage('en', {
    'Your passwords must match': 'Le password devono coincidere.', 
    'Password must have at least 8 characters': 'La password deve avere almeno 8 caratteri.', 
    'Incorrect username or password.': 'La password inserita non è corretta.'
  });
  
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const components = {
    ErrorMessage: () => (
      <>
        <Text color="red">Errore nell'aggiornamento della password!</Text>
      </>
    ),
    SubmitButton: (props) => (
      <AccountSettings.ChangePassword.SubmitButton
      {...props}
      variation="primary">{ loading ? <Loader/> : props.children }</AccountSettings.ChangePassword.SubmitButton>
    ),
    CurrentPasswordField: (props) => (
      <AccountSettings.ChangePassword.CurrentPasswordField
        {...props} 
        disabled={loading}
      />
    ),
    NewPasswordField: (props) => (
      <AccountSettings.ChangePassword.NewPasswordField
        {...props} 
        disabled={loading}
      />
    ),
    ConfirmPasswordField: (props) => (
      <AccountSettings.ChangePassword.ConfirmPasswordField
        {...props} 
        disabled={loading}
      />
    ),
  };
  
  return (
    <>
    <div className="profile-card-content">
      <Text fontWeight="600" fontSize="18px" marginBottom="20px">
        Cambia password
      </Text>
      <View width="400px">
        <AccountSettings.ChangePassword 
          components={components}
          onSuccess={() => {setShowConfirm(true); setLoading(false)}}
          onError={() => {setLoading(false)}}
          displayText={{currentPasswordFieldLabel: 'Password corrente', newPasswordFieldLabel: 'Nuova password', confirmPasswordFieldLabel: 'Conferma nuova password', updatePasswordButtonText: 'Conferma cambio password'}}
          />
        {showConfirm ? <Text>Password cambiata correttamente!</Text> : <></>}
      </View>
    </div>
    </>
  );
};

export default ProfilePassword;
